import React from 'react';

interface MarginsProps {
  height?: number | string;
  width?: number | string;
  iconColor?: string;
}

const Margins: React.FC<MarginsProps> = ({ height = 24, width = 24, iconColor = '#000' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        transform="scale(1.08) translate(-0.9, -0.9)"
        d="M 13.7,10.6 12.2,11.1 11.2,12 10.5,13.3 10.4,14.6 10.9,16 11.8,17 13.2,17.7 14.6,17.8 16,17.3 17.1,16.4 17.8,15.1 17.9,13.9 17.4,12.5 16.6,11.4 15,10.7 Z M 15.5,14.5 16.1,14.7 16.3,15.1 16.3,15.8 15.8,16.2 15.3,16.2 14.9,15.8 15,15 Z M 12.6,12.1 13.1,12.1 13.5,12.5 13.5,13.3 12.9,13.7 12.2,13.4 12,13 12.1,12.4 Z M 15.5,11.9 15.7,12.1 15.6,12.6 13.1,16.5 12.8,16.5 12.6,16.3 12.7,15.9 14.9,12.1 Z M 5.6,5.9 4.6,6.7 3.5,7.8 2.8,8.9 2.1,10.2 1.7,11.8 1.6,15.9 1.9,16.9 2.5,17.6 3.6,18 12.2,18 11.2,17.4 10.3,16.2 9.9,15.3 9.8,14.3 9.3,14.5 8.7,14.6 8.7,15.2 8.3,15.3 8.1,15.1 8.1,14.6 7.5,14.5 6.7,13.9 6.5,13.3 6.5,13 6.7,12.7 7.1,12.8 7.2,13.4 7.7,13.9 9.3,13.9 9.8,13.3 9.8,12.8 9.3,12.2 7.7,12.1 7.1,11.7 6.5,11 6.5,10.3 7.1,9.5 7.6,9.2 8.1,9.2 8.1,8.6 8.4,8.4 8.7,8.6 8.7,9.2 9.4,9.2 10.1,9.7 10.4,10.3 10.4,10.7 10,10.8 9.7,10.2 9.3,9.8 7.9,9.8 7.3,10.2 7.2,10.9 7.8,11.5 9.4,11.6 9.8,11.8 10.2,12.3 10.8,11.4 11.8,10.6 13.2,10 14.6,9.9 14.1,8.9 13.1,7.5 11.2,5.9 Z M 5,2.3 5,2.8 6.3,5.2 10.6,5.2 11.8,2.6 11.6,2 11.3,1.8 10.8,1.8 8.9,2.3 7.6,2.2 6.1,1.8 5.6,1.8 Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default Margins;
